import axiosInstance from '../api/axios';
import { IMaterial } from '../models/disciplines';

export async function markMaterialView(slug: string) {
  const response = await axiosInstance.post(`/workbooks/${slug}/opened`);

  return response.data;
}

export async function getMaterialBySlug(slug: string): Promise<IMaterial> {
  const response = await axiosInstance.get(`/materials/new/${slug}`);

  return response.data;
}
